import axios from "@/axios/axios";

const actions = {
  async GET_UNREAD_MESSAGES( context ) {
    return axios.get('chat_new_messages')
      .then(( { data } ) => context.commit('SET_UNREAD_MESSAGES', data));
  },
};

export default actions;
